import React from 'react'
import "./ComingSoon.css"
const ComingSoon = ({stakeConfirmPopup,setStakeConfirmPopup,isMLD}) => {
  return (
    <div class="coming-soon-backdrop" id="comingSoonPopup">
  <div class="coming-soon-modal">
    <button onClick={()=>setStakeConfirmPopup(false)} class="coming-soon-close" id="closePopup">&times;</button>
    <div class="coming-soon-badge">COMING SOON</div>
    <h2 class="coming-soon-title">{isMLD?"MLD Staking — Launching Soon":"NFT Staking — Launching Soon"}</h2>
    <p class="coming-soon-text">
      {isMLD?`We’re preparing the MLD staking feature. Stay tuned — it’ll be live soon!`:`We’re preparing the NFT staking feature. Stay tuned — it’ll be live soon!`}
    </p>
    <button onClick={()=>setStakeConfirmPopup(false)} class="coming-soon-btn" id="closeBtn">Got it</button>
  </div>
</div>
  )
}

export default ComingSoon